import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Layout from './components/Layout';
import LicenseList from './components/LicenseList';
import ProductList from './components/ProductList';
import ActivationList from './components/ActivationList';
import UserList from './components/UserList';
import AuditLogList from './components/AuditLogList';
import '@ant-design/v5-patch-for-react-19';
const PrivateRoute = ({ component: Component }) => {
    const token = localStorage.getItem('token');
    return token ? (
        <Layout>
            <Component />
        </Layout>
    ) : (
        <Navigate to="/login" />
    );
};

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/licenses" element={<PrivateRoute component={LicenseList} />} />
                <Route path="/products" element={<PrivateRoute component={ProductList} />} />
                <Route path="/activations" element={<PrivateRoute component={ActivationList} />} />
                <Route path="/users" element={<PrivateRoute component={UserList} />} />
                <Route path="/auditlogs" element={<PrivateRoute component={AuditLogList} />} />
                <Route path="/" element={<Navigate to="/licenses" />} />
            </Routes>
        </Router>
    );
};

export default App;
